import { isNullOrUndefined } from '@uzurv/core';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class AddressService {
  maskAddress(addressString: string): string {
    if (isNullOrUndefined(addressString)) {
      return null;
    }

    const firstWhitespaceIndex: number = addressString.indexOf(' ');
    const streetNumber = addressString.substring(0, firstWhitespaceIndex);

    // Return entire address string if there is no street number designation.
    const isNumbersOnly = /^\d+$/.test(streetNumber);
    if (!isNumbersOnly) {
      return addressString;
    }

    let maskedAddress = streetNumber;
    const remainingAddress = addressString.substring(firstWhitespaceIndex, addressString.length);

    if (streetNumber.length > 2) {
      maskedAddress = maskedAddress.substring(0, maskedAddress.length - 2);
      maskedAddress = maskedAddress + '**';
      return maskedAddress + remainingAddress;
    } else if (streetNumber.length === 2) {
      return '**' + remainingAddress;
    } else {
      return '*' + remainingAddress;
    }
  }
}
